import { MenuItem, TextField } from '@mui/material';

import type { Company } from '../api/business/types';
import { useT } from '../i18n/LanguageContext';

type CompanySelectorProps = {
  companies: Array<Company>;
  value: Company | null;
  onChange: (companyId: string) => void;
};

/** Which company the whole page is about — so it sits in the page header, not above a table (Conventions/08 §2). */
export const CompanySelector = ({ companies, value, onChange }: CompanySelectorProps) => {
  const t = useT();

  return (
    <TextField
      select
      size="small"
      label={t('field.company')}
      value={value?.id ?? ''}
      onChange={(event) => onChange(event.target.value)}
      sx={{ minWidth: 220 }}
    >
      {companies.map((company) => (
        <MenuItem key={company.id} value={company.id}>
          {company.name}
        </MenuItem>
      ))}
    </TextField>
  );
};
